import { name as storage } from "@modules/storage/storage.module";
import { name as accessor } from "@modules/accessor/accessor.module";
import { RestfulAccessorProvider } from "@core/data-access/restful";
import { PageObjectTreeService } from "@modules/basic/page/page-object-tree.service";
import { UserDataService } from "@modules/user/service/data/user-data-service";
import { UserDataProxy } from "./rest/data/user-data-proxy.service";
import { UserDataProxyConfig } from "./rest/data/user-data-proxy.config";
import { IUserData } from "./rest/data/user-data-proxy";

let module_name = "qp-user-data";

angular.module(module_name, [accessor, storage])
    .service({
        $objectTree: PageObjectTreeService,
        userDataProxy: UserDataProxy,
        userDataService: UserDataService,
    })
    .config(["$accessorProvider",
        function ($accessorProvider: RestfulAccessorProvider) {
            $accessorProvider.config(UserDataProxyConfig)
        }
    ])
    .run(["userDataService", "$objectTree", function (
        userDataService: UserDataService,
        $objectTree: PageObjectTreeService
    ) {
        // userDataService.getUserDataWithoutCache().then(res => {
        //     let userPreferences: IUserData = res;

        //     $objectTree.setCurrentPreference(userPreferences);
        // });
    }])

export { module_name }